import { ResponsiveSize, Shadow, ShadowTypes, Stack, StackTypes } from '@genial/components';
import { BoxRadius } from '@genial/design-tokens';
import React from 'react';

interface TableContentProps extends StackTypes.Props {
  children: React.ReactNode;
  isHighlighted?: boolean;
  spaceX?: ResponsiveSize;
  customShadowProps?: Partial<ShadowTypes.CompositeProps>;
}

export const TableContent: React.FC<TableContentProps> = ({
  children,
  isHighlighted,
  spaceX,
  customShadowProps,
  ...rest
}) => {
  return (
    <Shadow level={2} borderRadius={BoxRadius.sm} marginX={spaceX} {...customShadowProps}>
      <Stack
        space="inline.nano"
        justifyContent="space-between"
        alignItems="center"
        p="inline.xxs"
        borderRadius="sm"
        w="full"
        {...(isHighlighted && { bgColor: 'backgroundlight' })}
        {...rest}>
        {children}
      </Stack>
    </Shadow>
  );
};

export * from './addButton';
export * from './button';
export * from './badge';
export * from './captions';
export * from './column';
export * from './label';
export * from './text';
